import { createSlice } from "@reduxjs/toolkit";

const chatBotSlice = createSlice({
  name: "chatBot",
  initialState: {
    chatBot: [],
    isOpen: false,
  },
  reducers: {
    setChatBot: (state, action) => {
      state.chatBot = action.payload;
    },
    addChatMessage: (state, action) => {
      state.chatBot.push(action.payload);
    },
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    resetChatBot: (state) => {
      state.chatBot = [];
      state.isOpen = false;
    },
  },
});

export const { setChatBot, addChatMessage, setIsOpen, resetChatBot } = chatBotSlice.actions;
export default chatBotSlice.reducer;
